import { render } from "./LinkVenta.vue?vue&type=template&id=4cb26067&scoped=true"
import script from "./LinkVenta.vue?vue&type=script&lang=js"
export * from "./LinkVenta.vue?vue&type=script&lang=js"

import "./LinkVenta.vue?vue&type=style&index=0&id=4cb26067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb26067"]])

export default __exports__